module.exports = __webpack_public_path__ + "static/csod-og-image-default-420c62f1d1f652e0d71e106c3cea9b55.png";